/*
 * File: AsanaViewTask.tsx
 * Project: a-a
 * File Created: Thursday, 22nd May 2025 10:07:43 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 15th September 2025 11:07:59 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React, { useEffect, useState } from 'react';
import CustomDrawer from '../../../shared/CustomDrawer/CustomDrawer';
import { Box, Chip, Divider, Skeleton, Typography, useTheme } from '@mui/material';
import zeplinColor from '../../../../theme/Color';
import CustomPopOver from '../../../shared/CustomPopOver/CustomPopOver';
import { Link, useLocation } from 'react-router-dom';
import CustomButton from '../../../shared/CustomButton/CustomButton';
import dayjs from 'dayjs';
import { LightTooltip } from '../../../shared/CustomTooltip/CustomTooltip';
import CustomNotes from '../../../shared/CustomNotes/CustomNotes';
import CustomModal from '../../../shared/CustomModal/CustomModal';
import CustomCard from '../../../shared/CustomCard/CustomCard';
import CustomAlert from '../../../shared/CustomAlert/CustomAlert';
import CustomAlertContain from '../../../shared/CustomAlert/CustomAlertContain';
import { Constants } from '../../../../utilities/constants';
import { AsanaService } from '../../../../service/asana.service';
import AsanaAddTask from '../AsanaAddTask/AsanaAddTask';

const AsanaViewTask = ({
  drawerState,
  setDrawerState,
  selectedData,
  getTask,
}: {
  selectedData: any;
  drawerState: boolean;
  setDrawerState: React.Dispatch<React.SetStateAction<boolean>>;
  getTask: ((clear?: boolean, deleteTask?: boolean) => Promise<void>) | undefined;
}) => {
  const theme = useTheme();
  const location = useLocation();
  const ID = location.pathname.split('/')[2];
  const [selectedFiles, setSelectedFiles] = useState<File[] | any>(
    selectedData && selectedData?.attachments ? [...selectedData?.attachments] : [],
  );

  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [action, setAction] = useState('');
  const [msg, setMsg] = useState<{ message: string; type: 'Error' | 'Success' }>({
    message: '',
    type: 'Success',
  });
  const [taskById, setTaskById] = useState<any>();
  const [edit, setEdit] = useState(false);
  const [priority, setPriority] = useState<any>();
  const [status, setStatus] = useState<any>();
  const onClose = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    // setSelectedFiles([...selectedData?.attachments]);
    setDrawerState(open);
  };
  let selected = selectedData;
  const handleClose = () => {
    setOpenModal(false);
  };
  const handleAlertClose = () => {
    setMsg({ message: '', type: 'Success' });
  };

  const getById = async () => {
    try {
      setLoading(true);
      const res = await AsanaService.getAsanaTasksById(selected?.id);

      setTaskById(res);
      setSelectedFiles(res?.attachments);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    !edit && getById();
    getTaskBySection();
  }, [selected?.id, edit]);
  const handleCloseConfirm = () => {
    setOpenConfirmModal(false);
    setAction('');
  };
  const handleConfirm = async () => {
    try {
      setLoading(true);
      console.log('marked');
      const res = action
        ? await AsanaService.editAsanaTask(taskById?.task?.gid, {
            completed: action === 'mark' ? true : false,
          })
        : await AsanaService.deleteAsanaTask(taskById?.task?.gid);
      handleCloseConfirm();
      setMsg({
        type: 'Success',
        message: action === 'mark' ? 'Marked as completed' : 'Deleted task successfully',
      });

      if (action !== 'mark' && getTask) {
        // sessionStorage.setItem('delete-asana-task', 'true');
        // setDrawerState(false);
        getTask(false, true);
        return;
      } else {
        getById();
      }
    } catch (err) {
      setMsg({
        type: 'Error',
        message: 'Something went wrong',
      });
    } finally {
      setLoading(false);
    }
  };
  const getTaskBySection = async (clear?: boolean, deleteTask?: boolean) => {
    try {
      const res = await AsanaService.getAsanaTasksBySection(ID, {});

      setPriority(res.fieldOptions.priority.options);
      setStatus(res.fieldOptions.status.options);
    } catch (err: any) {
      return;
    }
  };
  const handleCopyLink = (val: any) => {
    // console.log() .
    navigator.clipboard.writeText(val);
    // setCopy('Copied Link');
    setMsg({ message: `Link Copied`, type: 'Success' });
  };
  return (
    <>
      {!edit ? (
        <CustomDrawer state={drawerState} onClose={onClose(false)}>
          <Box sx={{ width: '527px', position: 'relative', overflowY: 'scroll' }}>
            <Box
              sx={{
                position: 'sticky',
                top: 0,
                backgroundColor: zeplinColor.Neutral1,
                zIndex: '1',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '40px 24px 24px 24px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    gap: '16px',
                    alignItems: 'center',
                    // justifyContent: 'space-between',
                    // padding: '40px 24px 24px 24px',
                  }}
                >
                  {!taskById?.task?.completed ? (
                    <LightTooltip
                      title={
                        <Typography variant='body3' color={zeplinColor.Neutral1}>
                          Mark as complete
                        </Typography>
                      }
                      placement='bottom'
                      style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
                    >
                      <img
                        src={'/assets/mark-as-read.png'}
                        width={'24px'}
                        height={'24px'}
                        alt='mark-read'
                        style={{ cursor: 'pointer' }}
                        onClick={
                          loading
                            ? () => {}
                            : () => {
                                setAction('mark');
                                setOpenConfirmModal(true);
                              }
                        }
                      />
                    </LightTooltip>
                  ) : (
                    <LightTooltip
                      title={
                        <Typography variant='body3' color={zeplinColor.Neutral1}>
                          Mark as incomplete
                        </Typography>
                      }
                      placement='bottom'
                      style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
                    >
                      <img
                        src={'/assets/completed.png'}
                        width={'24px'}
                        height={'24px'}
                        alt='mark-read'
                        style={{ cursor: 'pointer' }}
                        onClick={
                          loading
                            ? () => {}
                            : () => {
                                setAction('unmark');
                                setOpenConfirmModal(true);
                              }
                        }
                      />
                    </LightTooltip>
                  )}
                  <LightTooltip
                    title={
                      <Typography variant='body3' color={zeplinColor.Neutral1}>
                        Copy link
                      </Typography>
                    }
                    placement='bottom'
                    style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
                  >
                    <img
                      src={'/assets/copy-view.png'}
                      width={'24px'}
                      height={'24px'}
                      alt='close'
                      style={{ cursor: 'pointer' }}
                      onClick={
                        loading
                          ? () => {}
                          : () => {
                              handleCopyLink(taskById?.task?.url);
                            }
                      }
                    />
                  </LightTooltip>
                  {/* <img
              src={'/assets/share.svg'}
              width={'24px'}
              height={'24px'}
              alt='close'
              style={{ cursor: 'pointer' }}
              //   onClick={OnClickSubTask}
            /> */}
                  <LightTooltip
                    title={
                      <Typography variant='body3' color={zeplinColor.Neutral1}>
                        Edit task
                      </Typography>
                    }
                    placement='bottom'
                    style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
                  >
                    <img
                      src={'/assets/edit.svg'}
                      width={'24px'}
                      height={'24px'}
                      alt='close'
                      style={{ cursor: 'pointer' }}
                      onClick={
                        loading
                          ? () => {}
                          : () => {
                              setEdit(true);
                            }
                      }
                    />
                  </LightTooltip>
                  <LightTooltip
                    title={
                      <Typography variant='body3' color={zeplinColor.Neutral1}>
                        Delete task
                      </Typography>
                    }
                    placement='bottom'
                    style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
                  >
                    <img
                      src={'/assets/delete.svg'}
                      width={'24px'}
                      height={'24px'}
                      alt='close'
                      style={{ cursor: 'pointer' }}
                      onClick={
                        loading
                          ? () => {}
                          : () => {
                              setAction('delete');
                              setOpenModal(true);
                            }
                      }
                    />
                  </LightTooltip>
                  {/* <img
              src={'/assets/vertical-dots.svg'}
              width={'24px'}
              height={'24px'}
              alt='close'
              style={{ cursor: 'pointer' }}
              onClick={handleClick}
            /> */}
                </Box>
                <img
                  src={'/assets/close-icon.svg'}
                  width={'24px'}
                  height={'24px'}
                  alt='close'
                  style={{ cursor: 'pointer' }}
                  onClick={onClose(false)}
                />
              </Box>
              <Divider
                component='div'
                sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }}
              />
            </Box>
            {/* <CustomPopOver
              setAnchorEl={setTaskAnchorEl}
              anchorEl={taskAnchorEl}
              id={idTask}
              sx={{
                borderRadius: '14px',
                boxShadow: 'rgba(0, 0, 0, 0.15)',
                marginTop: '8px',
                // marginRight: '2rem',
                // marginLeft: '-4rem',
              }}
            >
              <Box
                sx={{
                  height: '202px',
                  width: '340px',
                  padding: '24px',
                  display: 'flex',
                  gap: '32px',
                  flexDirection: 'column',
                }}
              >
                <Box sx={{ display: 'flex', gap: '16px', flexDirection: 'column' }}>
                  <Box sx={{ display: 'flex', gap: '12px', justifyContent: 'space-between' }}>
                    <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                      Authentication Required
                    </Typography>
                    <img
                      src={'/assets/close-icon.svg'}
                      width={24}
                      height={24}
                      alt='close'
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setTaskAnchorEl(null);
                      }}
                    />
                  </Box>

                  <Typography variant='body3' color={zeplinColor.BasicBlack}>
                    To create a new task, please ensure you're logged in to your Salesforce account.
                  </Typography>
                </Box>
                <Link
                  // target='_blank'
                  // rel='noopener noreferrer'
                  to={`https://${process.env.REACT_APP_SALESFORCE_URI}/services/oauth2/authorize?client_id=${process.env.REACT_APP_CLIENT_SALESFORCE}&redirect_uri=${process.env.REACT_APP_REDIRECT}&response_type=code`}
                >
                  <CustomButton
                    disabled={false}
                    onClick={() => {
                      setOpenModal(false);
                      setEdit(false);
                      sessionStorage.setItem('sf_redirect', 'Task');
                      sessionStorage.setItem('sf_edit_selected', JSON.stringify(selected));
                      sessionStorage.setItem('sf_task_status', selected?.status);
                      sessionStorage.setItem('sf_path', location?.pathname);
                      action === 'edit'
                        ? sessionStorage.setItem('sf_edit', 'true')
                        : action === 'markAsDone'
                        ? sessionStorage.setItem('sf_marked', 'true')
                        : sessionStorage.setItem('sf_delete', 'true');
                    }}
                    variant='contained'
                    color={'primary'}
                    style={{
                      width: '155px',
                      borderRadius: '14px',
                      height: '48px',
                      padding: '14px 16px',
                      '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
                    }}
                    textStyle={{ color: zeplinColor.Neutral1 }}
                    text={'Open Salesforce'}
                    // tabindex={4}
                  />
                </Link>
              </Box>
            </CustomPopOver> */}

            <Box sx={{ padding: '24px' }}>
              <Box sx={{ display: 'flex', gap: '24px', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', gap: '32px', flexDirection: 'column' }}>
                  <Box sx={{ display: 'flex', gap: '16px', flexDirection: 'column' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant='label1' color={zeplinColor.Neutral8}>
                          Created{' '}
                          {taskById?.task?.created_at
                            ? dayjs(taskById?.task?.created_at).format('D MMM, YYYY [at] h:mm A')
                            : 'NA'}
                        </Typography>
                      </Box>

                      <Typography variant='display5' color={zeplinColor.BasicBlack}>
                        {taskById?.task?.name || 'NA'}
                      </Typography>
                    </Box>
                    <Typography variant='body2' color={zeplinColor.BasicBlack}>
                      {taskById?.task?.notes || ''}
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', gap: '24px', flexDirection: 'column' }}>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/user-multiple.svg'
                        width={20}
                        height={20}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography variant='body2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
                        Assignee
                      </Typography>

                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Box
                          sx={{
                            display: 'flex',
                            gap: '4px',
                            flex: 1,
                            alignItems: 'center',
                          }}
                        >
                          <Box
                            sx={{
                              borderRadius: '100px',
                              padding: '10px',
                              width: '26px',
                              height: '26px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              backgroundColor: zeplinColor.Brand1,
                            }}
                          >
                            <Typography variant='label1' color={zeplinColor.Neutral1}>
                              {taskById?.task?.assignee?.name
                                ? taskById?.task?.assignee?.name
                                    ?.split(' ')
                                    .map((value: any, index: number) =>
                                      taskById?.task?.assignee?.name &&
                                      (index === 0 ||
                                        index ===
                                          taskById?.task?.assignee?.name.split(' ').length - 1)
                                        ? value[0]
                                        : '',
                                    )
                                : 'N/A'}
                            </Typography>
                          </Box>
                          <Typography variant='body2' style={{ wordBreak: 'break-word' }}>
                            {taskById?.task?.assignee?.name
                              ? taskById?.task?.assignee?.name
                              : 'N/A'}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/calendar-fade.svg'
                        width={20}
                        height={20}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography variant='body2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
                        Project
                      </Typography>

                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='body2' sx={{ flex: 1 }}>
                          {taskById?.task?.projects[0]?.name
                            ? taskById?.task?.projects[0]?.name
                            : 'N/A'}
                        </Typography>
                      )}
                    </Box>

                    <Box sx={{ display: 'flex', gap: '8px', flex: 1, alignItems: 'center' }}>
                      <img
                        src='/assets/status.svg'
                        width={20}
                        height={20}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography variant='body2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
                        Status
                      </Typography>
                      <Box sx={{ flex: 1 }}>
                        {loading ? (
                          <Skeleton
                            variant='text'
                            sx={{
                              fontSize: theme.typography.body2,
                              flex: 1,
                              // Optionally adjust other styles here
                            }}
                          />
                        ) : (
                          <Chip
                            label={
                              <Typography
                                variant='label1'
                                color={zeplinColor.Neutral1}
                                sx={{
                                  textAlign: 'center',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                }}
                              >
                                {taskById?.task?.status ?? 'N/A'}
                              </Typography>
                            }
                            sx={{
                              backgroundColor: zeplinColor.BasicBlack,
                              padding: '5px 14px 5px 14px',
                              borderRadius: '50px',
                              // width: '47px',
                              height: '29px',
                              '&.MuiChip-root': {
                                // flex: 1,
                              },
                              '& .MuiChip-label ': {
                                padding: 0,
                              },
                            }}
                          />
                        )}
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1, alignItems: 'centers' }}>
                      <img
                        src='/assets/priority.svg'
                        width={20}
                        height={20}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography variant='body2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
                        Priority
                      </Typography>
                      <Box sx={{ flex: 1 }}>
                        {loading ? (
                          <Skeleton
                            variant='text'
                            sx={{
                              fontSize: theme.typography.body2,
                              flex: 1,
                              // Optionally adjust other styles here
                            }}
                          />
                        ) : (
                          <Chip
                            label={
                              <Typography variant='label1'>{taskById?.task?.priority}</Typography>
                            }
                            sx={{
                              bgcolor:
                                Constants.PriorityTask[
                                  (selected?.priority || 'Medium') as 'Normal' | 'Low' | 'High'
                                ],
                              color: zeplinColor.Neutral1,
                              // width: '39px',
                              '&.MuiChip-root': {
                                height: '29px',
                                padding: '4px 14px',
                                borderRadius: '50px',
                              },
                              '& .MuiChip-label': {
                                padding: 0,
                              },
                            }}
                          />
                        )}
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
                      <img
                        src='/assets/calendar-fade.svg'
                        width={20}
                        height={20}
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography variant='body2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
                        Due Date
                      </Typography>

                      {loading ? (
                        <Skeleton
                          variant='text'
                          sx={{
                            fontSize: theme.typography.body2,
                            flex: 1,
                            // Optionally adjust other styles here
                          }}
                        />
                      ) : (
                        <Typography variant='body2' sx={{ flex: 1 }}>
                          {taskById?.task?.due_on
                            ? dayjs(taskById?.task?.due_on).format('DD MMM, YYYY')
                            : 'NA'}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Divider
                    component='div'
                    sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }}
                  />
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%',
                      alignItems: 'center',
                    }}
                  >
                    <Box sx={{ display: 'flex', gap: '8px', flex: 1, alignItems: 'center' }}>
                      <img
                        width={'20px'}
                        height={'20px'}
                        src={'/assets/attachment-view.png'}
                        alt='logo'
                        style={{ objectFit: 'fill' }}
                      />
                      <Typography variant='body2' color={zeplinColor.BasicBlack}>
                        Attachment
                      </Typography>
                    </Box>
                  </Box>
                  {!selectedFiles?.length ? (
                    // <CustomDragnDrop onDrop={onDrop} />
                    <></>
                  ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                      {selectedFiles.map((file: any, index: any) => (
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '12px',
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                            <img
                              width={'40px'}
                              height={'40px'}
                              src={
                                file?.name
                                  ? `/assets/${file?.name
                                      ?.split('.')
                                      [file?.name?.split('.')?.length - 1].toLocaleLowerCase()}.svg`
                                  : `/assets/${file
                                      ?.toString()
                                      .split('.')
                                      [
                                        file?.toString()?.split('.')?.length - 1
                                      ].toLocaleLowerCase()}.svg`
                              }
                              alt='file-type'
                              style={{ objectFit: 'fill' }}
                            />
                            <Box sx={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
                              <LightTooltip
                                title={
                                  <Typography variant='body3' color={zeplinColor.Neutral1}>
                                    {file.name}
                                  </Typography>
                                }
                                placement='bottom-end'
                                style={{
                                  backgroundColor: zeplinColor.BasicBlack,
                                  borderRadius: '8px',
                                }}
                              >
                                <Typography variant='body2'>
                                  {file?.name
                                    ? file?.name?.slice(0, 40)
                                    : file?.toString()?.slice(0, 40)}
                                  {file?.name
                                    ? file?.name?.length > 40 && '...'
                                    : file?.toString()?.length > 40 && '...'}
                                </Typography>
                              </LightTooltip>
                              <Typography variant='label1'>
                                {file?.size ? `${file?.size / 10000}MB` : ''}
                              </Typography>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              gap: '12px',
                              alignItems: 'center',
                              justifyContent: 'flex-end',
                            }}
                          >
                            <a
                              href={file?.download_url?.toString()}
                              download={file?.download_url?.toString()}
                              target='_blank'
                              rel='noopener noreferrer'
                              style={{ textDecoration: 'none' }}
                            >
                              <img
                                width={'24px'}
                                height={'24px'}
                                src={'/assets/download.svg'}
                                alt='logo'
                                style={{ objectFit: 'fill', cursor: 'pointer' }}
                                onClick={() => {}}
                              />
                            </a>
                            {/* <img
                          width={'20px'}
                          height={'20px'}
                          src={'/assets/vertical-dots.svg'}
                          alt='logo'
                          style={{ objectFit: 'fill', cursor: 'pointer' }}
                          onClick={() => deleteFile(index)}
                        /> */}
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
                <Divider
                  component='div'
                  sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }}
                />
              </Box>
            </Box>

            <Box>
              {/* <CustomNotes id={selected?.id} task={selected} parse_sf={parse_sf} setMsg={setMsg} /> */}
            </Box>
            <CustomModal handleClose={handleClose} open={openModal}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <CustomCard
                  styles={{
                    borderRadius: '14px',
                    padding: '24px',
                    backgroundColor: zeplinColor.Neutral1,

                    width: '312px',
                    height: '201px',
                    boxShadow: 'rgba(0, 0, 0, 0.15)',
                    // display: 'flex',
                    // flexDirection: 'column',
                    // justifyContent: 'space-between',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '32px',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px',
                      }}
                    >
                      <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                        Delete Task?
                      </Typography>
                      <Typography variant='body2' color={zeplinColor.BasicBlack}>
                        Are you sure you want to delete this task? This action cannot be undone.
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',

                        gap: '16px',
                      }}
                    >
                      <Box
                        onClick={handleClose}
                        sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                      >
                        <CustomCard
                          styles={{
                            borderRadius: '14px',
                            padding: '14px 32px',
                            backgroundColor: zeplinColor.Neutral1,
                            border: `1px solid ${zeplinColor.BasicBlack}`,
                            cursor: 'pointer',
                            // width: '312px',
                            // height: '183px',
                            display: 'flex',
                            justifyContent: 'center',
                            flex: 1,
                            // display: 'flex',
                            // flexDirection: 'column',
                            // justifyContent: 'space-between',
                          }}
                          aria-role='button'
                          aria-disable={loading}
                        >
                          <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                            Cancel
                          </Typography>
                        </CustomCard>
                      </Box>
                      <Box
                        onClick={() => {}}
                        sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                      >
                        <CustomCard
                          styles={{
                            borderRadius: '14px',
                            padding: '14px 32px',
                            backgroundColor: zeplinColor.Error,
                            cursor: 'pointer',
                            // border: `1px solid ${zeplinColor.BasicBlack}`,
                            // width: '312px',
                            // height: '183px',
                            display: 'flex',
                            justifyContent: 'center',
                            flex: 1,
                            // display: 'flex',
                            // flexDirection: 'column',
                            // justifyContent: 'space-between',
                          }}
                          aria-role='button'
                          aria-disable={loading}
                        >
                          <Typography
                            variant='buttonMedium'
                            color={zeplinColor.Neutral1}
                            sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                          >
                            Delete
                          </Typography>
                        </CustomCard>
                      </Box>
                    </Box>
                  </Box>
                </CustomCard>
                {/* {loading ? <CustomLoader /> : ''} */}
              </Box>
            </CustomModal>
          </Box>
          <CustomAlert
            open={msg.message ? true : false}
            handleClose={handleAlertClose}
            message={
              <CustomAlertContain
                alertIcon={
                  msg.type === 'Error' ? (
                    <img src='/assets/error.svg' width={24} height={24} />
                  ) : (
                    <img src='/assets/checkmark-green.png' width={24} height={24} />
                  )
                }
                alert={msg.message}
              />
            }
            error={msg.type === 'Error' ? true : false}
          />
        </CustomDrawer>
      ) : (
        <AsanaAddTask
          modalOpen={edit}
          setModalOpen={setEdit}
          data={taskById}
          // key={selectedProject?.id}
          getTask={() => getById()}
          // setEditedProject={setEditedProject}
          setMessage={(val: string) => {
            val.includes('successfully')
              ? setMsg({ type: 'Success', message: val })
              : setMsg({ type: 'Error', message: val });
          }}
          status={status}
          priority={priority}

          // assignee={assignee}
        />
      )}
      <CustomModal handleClose={handleCloseConfirm} open={openConfirmModal}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <CustomCard
            styles={{
              borderRadius: '14px',
              padding: '24px',
              backgroundColor: zeplinColor.Neutral1,

              // width: '312px',
              // height: '201px',
              boxShadow: 'rgba(0, 0, 0, 0.15)',
              // display: 'flex',
              // flexDirection: 'column',
              // justifyContent: 'space-between',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '32px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                }}
              >
                <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                  {action === 'mark'
                    ? 'Mark as Complete'
                    : action === 'unmark'
                    ? 'Mark as Incomplete'
                    : 'Delete Task?'}
                </Typography>
                {action ? (
                  <Typography variant='body2' color={zeplinColor.BasicBlack}>
                    Are you sure you want to mark this task as <br />
                    {action === 'mark' ? 'complete' : 'incomplete'}? You can always undo it later.
                  </Typography>
                ) : (
                  <Typography variant='body2' color={zeplinColor.BasicBlack}>
                    Are you sure you want to delete this task? This action cannot be undone.
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  display: 'flex',

                  gap: '16px',
                }}
              >
                <Box
                  onClick={handleCloseConfirm}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: zeplinColor.Neutral1,
                      border: `1px solid ${zeplinColor.BasicBlack}`,
                      cursor: 'pointer',
                      // width: '312px',
                      // height: '183px',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                      // display: 'flex',
                      // flexDirection: 'column',
                      // justifyContent: 'space-between',
                    }}
                    aria-role='button'
                    aria-disable={loading}
                  >
                    <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                      Cancel
                    </Typography>
                  </CustomCard>
                </Box>
                <Box
                  onClick={handleConfirm}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: loading
                        ? zeplinColor.Neutral8
                        : action
                        ? zeplinColor.Brand1
                        : zeplinColor.Error,
                      cursor: 'pointer',
                      // border: `1px solid ${zeplinColor.BasicBlack}`,
                      // width: '312px',
                      // height: '183px',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                      // display: 'flex',
                      // flexDirection: 'column',
                      // justifyContent: 'space-between',
                    }}
                    aria-role='button'
                    aria-disable={loading}
                  >
                    {action ? (
                      <Typography
                        variant='buttonMedium'
                        color={zeplinColor.Neutral1}
                        sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                      >
                        Mark {action === 'mark' ? 'Complete' : 'Incomplete'}
                      </Typography>
                    ) : (
                      <Typography
                        variant='buttonMedium'
                        color={zeplinColor.Neutral1}
                        sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                      >
                        {loading ? 'Deleting' : 'Delete'}
                      </Typography>
                    )}
                  </CustomCard>
                </Box>
              </Box>
            </Box>
          </CustomCard>
          {/* {loading ? <CustomLoader /> : ''} */}
        </Box>
      </CustomModal>
    </>
  );
};

export default AsanaViewTask;
